import { useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAuth } from '../context/AuthContext';
import { useVendorAuth } from '../context/VendorAuthContext';
import Slider from 'react-slick';
import { selectAllCoupons } from '../state/selectors';

const TopSellingTwo = () => {
    const sliderRef = useRef(null);
    const coupons = useSelector(selectAllCoupons);
    const navigate = useNavigate();
    const { isAuthenticated, isSubscribed } = useAuth();
    const { isVendorAuthenticated } = useVendorAuth();

    const handleCouponNavigateClick = (id) => {
        navigate(`/coupon/${id}`);
    };

    const maxDollarSavings = coupons.length > 0
        ? Math.max(...coupons.map(c => parseFloat(c.dollar_savings_amount) || 0))
        : 0;
    const maxSavingPercentage = coupons.length > 0
        ? Math.max(...coupons.map(c => parseFloat(c.saving_percentage) || 0))
        : 0;

    const settings = {
        dots: false,
        arrows: false,
        infinite: coupons.length > 4,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        variableWidth: true,
    };

    return (
        <section className="recommended pt-80">
            <style>{`
                .topsell2-card { box-shadow: 0 2px 16px rgba(0,0,0,0.05); border-color: #edf2f7 !important; }
                .topsell2-title { font-size: 20px; font-weight: 700; color: #0f172a; display: flex; align-items: center; gap: 10px; margin: 0; }
                .topsell2-accent { display: inline-block; width: 4px; height: 20px; background: linear-gradient(180deg, #4da8e8, #2575fc); border-radius: 2px; flex-shrink: 0; }
                .topsell2-view-all { font-size: 13px; font-weight: 600; color: #2575fc; padding: 6px 14px; border: 1px solid #dde9ff; border-radius: 99px; background: #f0f5ff; text-decoration: none; transition: background 0.15s, color 0.15s; }
                .topsell2-view-all:hover { background: #2575fc; color: #fff; }
                .topsell2-promo-col { box-shadow: 0 4px 20px rgba(99,62,143,0.18); }
                .topsell2-promo-label { font-size: 20px; font-weight: 700; letter-spacing: -0.1px; }
                .topsell2-promo-savings { font-size: 17px; font-weight: 500; opacity: 0.9; }
            `}</style>
            <div className="container container-lg">
                <div className="row g-12">
                    <div className="col-xxl-4">
                        <div className="d-flex align-items-center justify-content-center position-relative rounded-16 bg-light-purple overflow-hidden p-28 z-1 text-center h-100 topsell2-promo-col">
                            <img
                                src="assets/images/bg/recommended-bg.png"
                                alt=""
                                className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100 cover-img"
                            />
                            <div className="py-xl-4 text-center">
                                <span className="h6 mb-20 text-white topsell2-promo-label">
                                    Browse Top Coupons in your Area
                                </span>
                                <div className="flex-center gap-12 text-white mt-12">
                                    <span className="topsell2-promo-savings">Starting at</span>
                                    <h4 className="mb-8 text-white" style={{ fontSize: '34px' }}>${maxDollarSavings}</h4>
                                    <span className="badge-style-two position-relative me-8 bg-main-two-800 text-white py-2 px-8 rounded-4" style={{ fontSize: '15px' }}>
                                        Up to {maxSavingPercentage}% Off Savings
                                    </span>
                                </div>
                            </div>
                            {/* <img
                                src="assets/images/thumbs/recommended-img.png"
                                alt=""
                                className="mt-48 d-xxl-block d-none"
                            /> */}
                        </div>
                    </div>

                    <div className="col-xxl-8">
                    <div className="border border-gray-100 p-24 rounded-16 h-100 topsell2-card">
                    <div className="section-heading mb-24">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="topsell2-title">
                                <span className="topsell2-accent" />
                                Recommended For You
                            </h5>
                            <div className="flex-align mr-point gap-16">
                                <Link to="/shop" className="topsell2-view-all">View All Coupons→</Link>
                            </div>
                        </div>
                    </div>

                    <div className="top-selling-product-wrapper position-relative" style={{ paddingRight: '56px' }}>
                        <div className="top-selling-product-slider">
                            <Slider ref={sliderRef} {...settings}>
                                {Array.isArray(coupons) && coupons.length > 0 ? (
                                    coupons.map((coupon, key) => (
                                        <div key={key} style={{ width: '260px', paddingRight: '16px', boxSizing: 'border-box' }}>
                                            <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">

                                                <div
                                                    onClick={() => handleCouponNavigateClick(coupon.id)}
                                                    className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                                                    style={{ overflow: 'hidden', cursor: 'pointer' }}
                                                >
                                                    <span className="product-card__badge bg-main-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                                                        New
                                                    </span>

                                                    {coupon.image_url ? (
                                                        <img
                                                            src={coupon.image_url}
                                                            alt=""
                                                            style={{ width: '100%', height: '100%', maxWidth: 'none', maxHeight: 'none', objectFit: 'cover', position: 'absolute', inset: 0 }}
                                                        />
                                                    ) : (
                                                        <img
                                                            src="assets/images/thumbs/product-two-img7.png"
                                                            alt=""
                                                            className="w-auto max-w-unset"
                                                        />
                                                    )}
                                                </div>

                                                {coupon.business_name && (
                                                    <div className="flex-align gap-4" style={{ marginTop: "12px" }}>
                                                        <span className="text-tertiary-600 text-sm d-flex"><i className="ph-fill ph-storefront" /></span>
                                                        <span className="text-lg fw-semibold text-gray-500" style={{ fontFamily: "var(--heading-font)", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block', minWidth: 0 }}>{coupon.business_name}</span>
                                                    </div>
                                                )}

                                                <div className="product-card__content w-100 mt-16">
                                                    <div className="flex-align gap-6">
                                                        <div className="flex-align gap-4">
                                                            {[1, 2, 3, 4, 5].map(star => (
                                                                <span key={star} className={`text-xs fw-medium d-flex ${star <= Math.round(coupon.average_rating || 0) ? 'text-warning-600' : 'text-gray-300'}`}>
                                                                    <i className="ph-fill ph-star" />
                                                                </span>
                                                            ))}
                                                        </div>
                                                        <span className="text-xs fw-medium text-gray-500">{coupon.average_rating ?? "—"}</span>
                                                        <span className="text-xs fw-medium text-gray-500">({coupon.rating_count ?? 0})</span>
                                                    </div>

                                                    <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                                        <div
                                                            onClick={() => handleCouponNavigateClick(coupon.id)}
                                                            className="link d-block"
                                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                        >
                                                            {coupon.title}
                                                        </div>
                                                    </h6>

                                                    {coupon.description && (
                                                        <p className="text-sm text-gray-500 mb-8" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                            {coupon.description}
                                                        </p>
                                                    )}

                                                    <div className="product-card__price my-20 flex-align gap-4">
                                                        <span className="text-heading text-md fw-semibold">
                                                            ${coupon.dollar_savings_amount}
                                                        </span>
                                                        <span className="text-gray-500 text-sm fw-medium">In Savings</span>
                                                        <span style={{ width: '1px', height: '14px', backgroundColor: '#d1d5db', display: 'inline-block', margin: '0 4px' }} />
                                                        <span className="text-main-800 text-sm fw-semibold">{coupon.saving_percentage}% Off</span>
                                                    </div>

                                                    {!isVendorAuthenticated && (
                                                        isAuthenticated && isSubscribed ? (
                                                            <Link
                                                                to={`/coupon/${coupon.id}`}
                                                                className="product-card__cart w-100 btn bg-main-800 text-white hover-bg-main-700 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium w-100"
                                                            >
                                                                Redeem Coupon <i className="ph ph-shopping-cart" />
                                                            </Link>
                                                        ) : (
                                                            <Link
                                                                to={isAuthenticated ? "/cart" : "/account-login"}
                                                                state={{ from: `/coupon/${coupon.id}` }}
                                                                className="product-card__cart w-100 btn bg-main-800 text-white hover-bg-main-700 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium w-100"
                                                            >
                                                                Buy Fun Card <i className="ph ph-shopping-cart" />
                                                            </Link>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div>No coupons available</div>
                                )}
                            </Slider>
                        </div>

                        <button
                            type="button"
                            onClick={() => sliderRef.current?.slickNext()}
                            className="flex-center rounded-circle text-xl"
                            style={{
                                position: 'absolute',
                                right: 0,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                zIndex: 10,
                                width: '40px',
                                height: '40px',
                                background: 'linear-gradient(135deg, #4da8e8 0%, #2575fc 100%)',
                                border: 'none',
                                boxShadow: '0 4px 12px rgba(37,117,252,0.32)',
                                cursor: 'pointer',
                                transition: 'opacity 0.15s, transform 0.15s, box-shadow 0.15s',
                            }}
                            onMouseEnter={e => { e.currentTarget.style.opacity = '0.88'; e.currentTarget.style.transform = 'translateY(-50%) scale(1.09)'; e.currentTarget.style.boxShadow = '0 6px 18px rgba(37,117,252,0.45)'; }}
                            onMouseLeave={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'translateY(-50%)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(37,117,252,0.32)'; }}
                        >
                            <i className="ph ph-caret-right" style={{ color: 'white' }} />
                        </button>
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TopSellingTwo;
